import { Component, type ErrorInfo, ReactNode } from 'react';
import { errorMessage } from '../consts';
import { LoadingContext } from '../providers/LoadingProvider';
import { logger } from '../utils';

type Props = { children: ReactNode };
type State = { error: Error | null; componentStack: string | null };

export default class ErrorBoundary extends Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = { error: null, componentStack: null };
	}

	static contextType = LoadingContext;

	// Catch/save errors in component stack and clear loading spinner
	public componentDidCatch(error: Error, { componentStack }: ErrorInfo) {
		logger(`Uncaught error: ${componentStack}`, error.toString());
		this.setState({ error, componentStack: componentStack ?? null });
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		(this.context as any).resetLoadingSequences();
	}

	public render() {
		// Render error overview
		if (this.state.componentStack) {
			return (
				<>
					<h2>{errorMessage}</h2>
					<details open>
						<summary>{this.state.error?.toString()}</summary>
						<pre>{this.state.componentStack}</pre>
					</details>
				</>
			);
		}

		return this.props.children;
	}
}
